module.exports = __webpack_public_path__ + "static/media/archero2_page_area04_img_cn@2x.eef474d5.jpg";